/**
 * @file TabCallsHistory.jsx
 * @description TabCallsHistory component for displaying and managing tab calls history.
 * @component TabCallsHistory
 * @exports TabCallsHistory - Main component for displaying and managing tab calls history.
 */

import React, { useState, useEffect } from "react";
import {
  Box,
  //Typography,
  //TextField,
  //Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { getcustomercalls } from "../../../services/customerinfoModule/historyServices";
import { fetchCustomerCallChart } from "../../../services/dashboardModule/dashboardServices";
import CustomerDashCallChart from "../../dashboard/customersDash/charts/CustomerDashCallChart";

const CustomerCallsHistory = ({ customerguid, isDash = false }) => {
  const [callshistory, setCallsHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const fetchChart = async () => {
      try {
        const data = await fetchCustomerCallChart(customerguid);
        setChartData(data || []);
      } catch (error) {
        console.error("Error fetching call chart:", error);
      }
    };

    if (customerguid) {
      fetchCallsHistory();
      if (isDash) fetchChart();
    }
  }, [customerguid, isDash]);

  const fetchCallsHistory = async () => {
    setLoading(true);
    try {
      const data = await getcustomercalls({ customerguid });
      setCallsHistory(data || []);
    } catch (error) {
      console.error("Error fetching callshistory:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return "—";
    const date = new Date(isoDate);
    return date.toLocaleString();
  };
  return (
    <Box sx={{ p: 2 }}>
      {isDash && (
        <CustomerDashCallChart
          rows={chartData}
          title="Call Volume"
          label="Calls"
          isCurrency={false}
        />
      )}
      <TableContainer
        component={Paper}
        sx={{ maxHeight: 500, overflowY: "auto" }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Connection ID</b>
              </TableCell>
              <TableCell>
                <b>Customer Number</b>
              </TableCell>
              <TableCell>
                <b>Status</b>
              </TableCell>
              <TableCell>
                <b>Created At</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            ) : callshistory.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No calls found
                </TableCell>
              </TableRow>
            ) : (
              callshistory.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.callconnectionid}</TableCell>
                  <TableCell>{item.customeracsid}</TableCell>
                  <TableCell>{item.status}</TableCell>
                  <TableCell>{formatDate(item.createdat)}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CustomerCallsHistory;
